// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --gray-darker: #141414;
  --gray-dark: #696969;
  --gray: #999999;
  --gray-light: #cccccc;
  --gray-lighter: #ececec;
  --gray-lightest: #f5f5f5;
}
.cards .cards__item{
    /* height: fit-content; */
}
.cards .cards__item .card img {
  height: 250px;
  width: 100%;
  object-fit: cover;
  vertical-align: middle;
  display: block;
  margin: 0 auto;
}

@media (max-width: 640px) {
  .cards .cards__item .card img {
    height: 200px;
  }
}

.btn {
  background-color: white;
  border: 1px solid var(--gray-light);
  /* //border-radius: 1rem; */
  color: var(--gray-dark);
  padding: 0.5rem;
  text-transform: lowercase;
}

.btn--block {
  display: block;
  width: 100%;
}
 
.cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
  gap: 1.5rem;
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
  max-width: 100%;
}

.cards__item {
  /* display: flex; */
  padding: 0;
  width: 100%;
  min-width: 0;
  overflow: hidden;
}

/* Responsive grid adjustments */
/* @media (max-width: 1400px) {
  .cards {
    grid-template-columns: repeat(3, 1fr);
    gap: 1.25rem;
  }
} */

/* @media (max-width: 1024px) {
  .cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
}

@media (max-width: 640px) {
  .cards {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
} */
.modal-content .body {
  display: flex;
  justify-content: flex-start;
  gap: 20px;
  align-items: center;
}

/* Responsive modal content */
@media (max-width: 768px) {
  .modal-content .body {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }
  
  .modal-content .body > div {
    width: 100% !important;
    flex: none !important;
  }
  
  .modal-content .body img {
    width: 100%;
    max-height: 300px;
    object-fit: cover;
  }
  
  .modal-content .body p {
  }
}

@media (max-width: 480px) {
  .modal-content .body {
    gap: 12px;
  }
  
  .modal-content .body img {
    max-height: 250px;
  }
  
  
}

.body {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  box-sizing: border-box;
}

.readmore{
  
}
.card__image:hover{
  scale: 1.02;
}

.card {
  background-color: white;
  border-radius: 15px;
  /* box-shadow: 0 20px 40px -14px rgba(0,0,0,0.25); */
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  height: 100%;
  min-height: 400px;
  width: 100%;
  transition: transform 0.2s ease;
}

@media (max-width: 640px) {
  .card {
    min-height: 350px;
  }
}

.card:hover .card__image {
  filter: contrast(100%);
}

.card__content {
  display: flex;
  flex: 1 1 auto;
  flex-direction: row;
  /* padding: 0 1rem; */
  margin: 20px;
}

.card__image {
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  /* filter: contrast(70%); */
  /* //filter: saturate(180%); */
  overflow: hidden;
  position: relative;
  /* transition: filter 0.5s cubic-bezier(.43,.41,.22,.91); */
}

.card__image::before {
  /* content: ""; */
  display: block;
  /* padding-top: 56.25%; 16:9 aspect ratio */
}

@media(min-width: 40rem) {
  .card__image::before {
    /* padding-top: 66.6%; 3:2 aspect ratio */
  }
}



.card__title {
  color: var(--gray-darker);
}
.card__title h3{
  text-align: left;
  margin-bottom: 10px;
}
.card__text {
  flex: 1 1 auto;
  margin-bottom: 1.25rem;
}

.card__text--truncate {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0.5rem;
}


.mediaUploads .cards{
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/industry.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;IACI,yBAAyB;AAC7B;AACA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;;;;;GAKG;;AAEH;;;;;;;;;;;;GAYG;AACH;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;EACA;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;;AAGF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;AAEA;AACA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,oDAAoD;EACpD,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,sBAAsB;EACtB,+BAA+B;EAC/B,gCAAgC;EAChC,2BAA2B;EAC3B,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,2DAA2D;AAC7D;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE;IACE,yCAAyC;EAC3C;AACF;;;;AAIA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;;AAGA;EACE,eAAe;AACjB","sourcesContent":[":root {\n  --gray-darker: #141414;\n  --gray-dark: #696969;\n  --gray: #999999;\n  --gray-light: #cccccc;\n  --gray-lighter: #ececec;\n  --gray-lightest: #f5f5f5;\n}\n.cards .cards__item{\n    /* height: fit-content; */\n}\n.cards .cards__item .card img {\n  height: 250px;\n  width: 100%;\n  object-fit: cover;\n  vertical-align: middle;\n  display: block;\n  margin: 0 auto;\n}\n\n@media (max-width: 640px) {\n  .cards .cards__item .card img {\n    height: 200px;\n  }\n}\n\n.btn {\n  background-color: white;\n  border: 1px solid var(--gray-light);\n  /* //border-radius: 1rem; */\n  color: var(--gray-dark);\n  padding: 0.5rem;\n  text-transform: lowercase;\n}\n\n.btn--block {\n  display: block;\n  width: 100%;\n}\n \n.cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));\n  gap: 1.5rem;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  max-width: 100%;\n}\n\n.cards__item {\n  /* display: flex; */\n  padding: 0;\n  width: 100%;\n  min-width: 0;\n  overflow: hidden;\n}\n\n/* Responsive grid adjustments */\n/* @media (max-width: 1400px) {\n  .cards {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 1.25rem;\n  }\n} */\n\n/* @media (max-width: 1024px) {\n  .cards {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1rem;\n  }\n}\n\n@media (max-width: 640px) {\n  .cards {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n} */\n.modal-content .body {\n  display: flex;\n  justify-content: flex-start;\n  gap: 20px;\n  align-items: center;\n}\n\n/* Responsive modal content */\n@media (max-width: 768px) {\n  .modal-content .body {\n    flex-direction: column;\n    gap: 15px;\n    align-items: flex-start;\n  }\n  \n  .modal-content .body > div {\n    width: 100% !important;\n    flex: none !important;\n  }\n  \n  .modal-content .body img {\n    width: 100%;\n    max-height: 300px;\n    object-fit: cover;\n  }\n  \n  .modal-content .body p {\n  }\n}\n\n@media (max-width: 480px) {\n  .modal-content .body {\n    gap: 12px;\n  }\n  \n  .modal-content .body img {\n    max-height: 250px;\n  }\n  \n  \n}\n\n.body {\n  width: 100%;\n  max-width: 100%;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.readmore{\n  \n}\n.card__image:hover{\n  scale: 1.02;\n}\n\n.card {\n  background-color: white;\n  border-radius: 15px;\n  /* box-shadow: 0 20px 40px -14px rgba(0,0,0,0.25); */\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  position: relative;\n  height: 100%;\n  min-height: 400px;\n  width: 100%;\n  transition: transform 0.2s ease;\n}\n\n@media (max-width: 640px) {\n  .card {\n    min-height: 350px;\n  }\n}\n\n.card:hover .card__image {\n  filter: contrast(100%);\n}\n\n.card__content {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: row;\n  /* padding: 0 1rem; */\n  margin: 20px;\n}\n\n.card__image {\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n  /* filter: contrast(70%); */\n  /* //filter: saturate(180%); */\n  overflow: hidden;\n  position: relative;\n  /* transition: filter 0.5s cubic-bezier(.43,.41,.22,.91); */\n}\n\n.card__image::before {\n  /* content: \"\"; */\n  display: block;\n  /* padding-top: 56.25%; 16:9 aspect ratio */\n}\n\n@media(min-width: 40rem) {\n  .card__image::before {\n    /* padding-top: 66.6%; 3:2 aspect ratio */\n  }\n}\n\n\n\n.card__title {\n  color: var(--gray-darker);\n}\n.card__title h3{\n  text-align: left;\n  margin-bottom: 10px;\n}\n.card__text {\n  flex: 1 1 auto;\n  margin-bottom: 1.25rem;\n}\n\n.card__text--truncate {\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 0.5rem;\n}\n\n\n.mediaUploads .cards{\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
